import { WPlayer } from '../../model/websocket/WPlayer';
import tableStore from '../../store/TableStore';
import { WEvent } from './WEvent';

export class WPlayerSitEvent extends WEvent {
  pid: string;
  players: WPlayer[];

  constructor(event: WPlayerSitEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  public applyWebsocketChanges = (): Promise<void> =>
    tableStore.findActiveTableById(this.tableId).then(table => {
      table.setPlayers(this.players);
      table.removeWaitingHostBot(this.pid);
      tableStore.changeFilterState();
    });
}
